.loading-container {
  padding-top: calc(var(--spacer) * 10);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  gz-progress-spinner {
    display: flex;
    justify-content: center;
  }
}
